import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { getCSRFToken } from "../common/Csrf";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Toolbar from "@material-ui/core/Toolbar";
import { IconButton } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";

import EnhancedTableHead from "../common/EnhancedTableHead";
import CustomTableCell from "../common/TableCell";
import * as authActions from "../auth/actions";

const styles = (theme) => ({
    flex: {
        flex: 1,
    },
    historyPaper: {
        minWidth: 900,
        maxWidth: "95vw",
    },
    progress: {
        display: "table",
        margin: "24px auto",
    },
    message: {
        textAlign: "center",
        margin: "16px 0",
    },
    redText: {
        color: "#f00f0f",
    },
    changeList: {
        margin: 0,
        paddingLeft: 18,
    },
    // bounded, scrollable table body with the column header pinned in place.
    // Scoped here so it doesn't affect other EnhancedTableHead usages.
    scrollContainer: {
        maxHeight: "60vh",
        overflow: "auto",
        "& thead th": {
            position: "sticky",
            top: 0,
            zIndex: 2,
        },
    },
});

const columnData = [
    { id: "item", numeric: false, label: "Item", allowSort: false, width: "auto" },
    { id: "date", numeric: false, label: "Date", allowSort: false, width: 170 },
    { id: "user", numeric: false, label: "User", allowSort: false, width: 120 },
    { id: "type", numeric: false, label: "Change Type", allowSort: false, width: 110 },
    { id: "changes", numeric: false, label: "Changed Attributes", allowSort: false, width: "auto" },
];

//Dialog showing the simple-history audit of field changes for a single form (see modules/history.py -> /fieldhistory/form/<form_id>)
class FormFieldHistory extends Component {
    state = {
        loading: false,
        rows: [],
        error: null,
    };

    componentDidUpdate(prevProps) {
        //Only fetch when the dialog is first opened so we always show the latest history.
        if (this.props.open && !prevProps.open) {
            this.loadHistory();
        }
    }

    loadHistory = () => {
        const { form, authState, authLogout, history } = this.props;
        if (!form) {
            return;
        }
        this.setState({ loading: true, error: null });
        fetch(`/fieldhistory/form/${form.id}?format=json&t=${Date.now()}`, {
            headers: {
                Accept: "application/json",
                "X-CSRFToken": getCSRFToken(),
            },
        })
            .then((res) => {
                if (res.status === 401 || res.status === 403) {
                    authLogout(authState, history);
                    throw new Error("Not authorized");
                }
                if (!res.ok) {
                    throw new Error("Unable to load history.");
                }
                return res.json();
            })
            .then((rows) => this.setState({ loading: false, rows: rows || [] }))
            .catch((e) => this.setState({ loading: false, error: e.message }));
    };

    //render a value the backend diff may return as null/boolean/object
    formatValue = (val) => {
        if (val === null || val === undefined || val === "") {
            return "(empty)";
        }
        if (typeof val === "object") {
            return JSON.stringify(val);
        }
        return String(val);
    };

    render() {
        const { classes, open, returnDialog } = this.props;
        const { loading, rows, error } = this.state;

        return (
            <Dialog open={open} classes={{ paper: classes.historyPaper }} onClose={returnDialog}>
                <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                    <Typography variant="h5" className={classes.flex}>
                        Form Change History (Ordered by Most Recent)
                    </Typography>
                    <IconButton aria-label="Close Dialog" onClick={returnDialog}>
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent style={{ paddingRight: 0 }}>
                    <DialogContentText>
                        {loading && <CircularProgress size={28} className={classes.progress} />}
                        {!loading && error && (
                            <Typography className={`${classes.message} ${classes.redText}`}>{error}</Typography>
                        )}
                        {!loading && !error && rows.length === 0 && (
                            <Typography className={classes.message}>No field history has been recorded for this form yet.</Typography>
                        )}
                        {!loading && !error && rows.length > 0 && (
                            <div className={classes.scrollContainer}>
                            <Table>
                                <EnhancedTableHead columnData={columnData} />
                                <TableBody>
                                    {rows.map((row, idx) => (
                                        <TableRow hover key={`${row.object_type}-${row.record_id}-${idx}`}>
                                            <CustomTableCell>{row.item}</CustomTableCell>
                                            <CustomTableCell>{row.date ? new Date(row.date).toLocaleString() : ""}</CustomTableCell>
                                            <CustomTableCell>{row.user || "—"}</CustomTableCell>
                                            <CustomTableCell>{row.type}</CustomTableCell>
                                            <CustomTableCell>
                                                {row.changes && row.changes.length > 0 ? (
                                                    <ul className={classes.changeList}>
                                                        {row.changes.map((c, i) => (
                                                            <li key={i}>
                                                                <strong>{c.field}:</strong> {this.formatValue(c.old)} → {this.formatValue(c.new)}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    "—"
                                                )}
                                            </CustomTableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            </div>
                        )}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}
FormFieldHistory.displayName = "FormFieldHistory";
FormFieldHistory = connect(() => null, {
    ...authActions,
})(FormFieldHistory);

export default withStyles(styles)(withRouter(FormFieldHistory));
